// This message is referenced in LocalRuntimeJSEngine.kt.
export const CIRCUIT_BREAKER_MSG = 'ServerCallRequired';
// to-do: use TypeScript to reference this function in SandboxedRuntimeLite.
/** @arg method API method called for debugging. Eg, UserDataByAccountIds. */
export function CircuitBreak(method) {
    // Warning: this function is serialized by SandboxRuntimeLite. Don't use
    // import dependencies.
    // Error must be postable.
    const err = Error('ServerCallRequired');
    err.cause = { method, stack: err.stack };
    return err;
}
export class CircuitBreakerResponse extends Error {
    constructor(response, cause) {
        super(CIRCUIT_BREAKER_MSG);
        this.response = response;
        this.cause = cause;
        this.name = 'CircuitBreakerResponse';
    }
}
export function isCircuitBreaker(err) {
    return err?.message === CIRCUIT_BREAKER_MSG;
}
